import ApiService from "@/common/services/http/api.service";

const MarcaDocumentoConfigService = {
  /**
   * Buscar ScoreCards
   * @returns {*}
   */
  async getMarcaDocumentoConfig(clientID) {
    const { data: result } = await ApiService.get(
      "/MarcaDocumentoConfig",
      clientID
    );
    return result;
  },
  async saveMarcaDocumentoConfig(dados) {
    const { data: result } = await ApiService.patch(
      "/MarcaDocumentoConfig",
      dados
    );
    return result;
  },
  async getProperiedadesMarcaDocumentoConfig() {
    const { data: result } = await ApiService.get(
      "/MarcaDocumentoConfig/propriedades"
    );
    return result;
  },
  async visualizarMarcaDocumentoConfig(dados) {
    const { data: result } = await ApiService.put(
      "/MarcaDocumentoConfig/visualizar",
      dados,
      { responseType: "blob" }
    );
    return result;
  },
};

export default MarcaDocumentoConfigService;
